import {Module} from "../index";
import Initializer from "@/modules/database/services/Initializer";
import {applyPolyfills, defineCustomElements as jeepSqlite} from 'jeep-sqlite/loader';

export class DatabaseModule extends Module {
  public entities = [];

  protected register() {
    super.register();

    applyPolyfills().then(() => {
      jeepSqlite(window);
    });

    this.app.bind<Initializer>(Initializer).to(Initializer).inSingletonScope();
  }

  boot() {
    super.boot();

    this.app.get(Initializer).init();
  }
}
